import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { ApplicationShared } from 'core'
import { UnavailablePageWrapper, UnavailablePageTitle, UnavailablePageDescription, UnavailablePageButtons, BackButton, MainButton, UnavailablePageWrapperOuter } from './styles'
import { getLastApp, getLastPath } from 'routeHistory'

export const Unavailable: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [showBack, setShowBack] = useState(false)

  useEffect(() => {
    let canGoBack = false;
    const currentApp = ApplicationShared.application;
  
    if (getLastPath() && getLastApp() === currentApp) {
      canGoBack = true;
    }
  
    if (!canGoBack && document.referrer) {
      try {
        const sameOrigin = new URL(document.referrer).origin === window.location.origin;
        const sameApp    = getLastApp() === currentApp;
        console.log('📋 sameOrigin =', sameOrigin, 'sameApp =', sameApp);
        if (sameOrigin && sameApp) {
          canGoBack = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }
  
    setShowBack(canGoBack);
  }, []);
  

  const handleGoBack = useCallback(() => {
    if (getLastPath() && getLastApp() === ApplicationShared.application) {
      history.replace(getLastPath())
    } else {
      history.goBack()
    }
  }, [history])

  const handleGoHome = useCallback(() => {
    history.replace('/')
  }, [history])

  return (
    <UnavailablePageWrapperOuter>
      <UnavailablePageWrapper>
        <UnavailablePageTitle>{t('unavailable.title')}</UnavailablePageTitle>
        <UnavailablePageDescription>{t('unavailable.project_subtitle')}</UnavailablePageDescription>
      </UnavailablePageWrapper>
      <UnavailablePageButtons>
        {showBack && (
          <BackButton onClick={handleGoBack}>
            {t('unavailable.back')}
          </BackButton>
        )}
        <MainButton onClick={handleGoHome}>
          {t('unavailable.main')}
        </MainButton>
      </UnavailablePageButtons>
    </UnavailablePageWrapperOuter>
  )
}

export default Unavailable
import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { ApplicationShared } from 'core'
import { UnavailablePageWrapper, UnavailablePageTitle, UnavailablePageDescription, UnavailablePageButtons, BackButton, MainButton, UnavailablePageWrapperOuter } from './styles'
import { getLastApp, getLastPath } from 'routeHistory'

export const Unavailable: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [showBack, setShowBack] = useState(false)

  useEffect(() => {
    let canGoBack = false;
    const currentApp = ApplicationShared.application;
  
    if (getLastPath() && getLastApp() === currentApp) {
      canGoBack = true;
    }
  
    if (!canGoBack && document.referrer) {
      try {
        const sameOrigin = new URL(document.referrer).origin === window.location.origin;
        const sameApp    = getLastApp() === currentApp;
        console.log('📋 sameOrigin =', sameOrigin, 'sameApp =', sameApp);
        if (sameOrigin && sameApp) {
          canGoBack = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }
  
    setShowBack(canGoBack);
  }, []);
  

  const handleGoBack = useCallback(() => {
    if (getLastPath() && getLastApp() === ApplicationShared.application) {
      history.replace(getLastPath())
    } else {
      history.goBack()
    }
  }, [history])

  const handleGoHome = useCallback(() => {
    history.replace('/')
  }, [history])

  return (
    <UnavailablePageWrapperOuter>
      <UnavailablePageWrapper>
        <UnavailablePageTitle>{t('unavailable.title')}</UnavailablePageTitle>
        <UnavailablePageDescription>{t('unavailable.project_subtitle')}</UnavailablePageDescription>
      </UnavailablePageWrapper>
      <UnavailablePageButtons>
        {showBack && (
          <BackButton onClick={handleGoBack}>
            {t('unavailable.back')}
          </BackButton>
        )}
        <MainButton onClick={handleGoHome}>
          {t('unavailable.main')}
        </MainButton>
      </UnavailablePageButtons>
    </UnavailablePageWrapperOuter>
  )
}

export default Unavailable
